export const SESSION_OPTIONS = [
  'Day Session',
  'Overnight',
  '24hr',
  '48hr',
  '5 Day',
  '7 Day',
];

export const SESSION_MAPPING = {
  'Day Session': 'day_session',
  Overnight: 'overnight',
  '24hr': '24',
  '48hr': '48',
  '5 Day': String(5 * 24), // 120
  '7 Day': String(7 * 24), // 168
};

export const REVERSE_SESSION_MAPPING = {
  day_session: 'Day Session',
  overnight: 'Overnight',
  24: '24hr',
  48: '48hr',
  120: '5 Day',
  168: '7 Day',
};

export const BOOKING_TYPE_MAPPING = {
  specificSwims: 'swim',
  watercraftTickets: 'ticket',
  lakeExclusives: 'lake_exclusive',
  accommodation: 'accommodation',
};

export const REVERSE_BOOKING_TYPE_MAPPING = {
  swim: 'specificSwims',
  ticket: 'watercraftTickets',
  lake_exclusive: 'lakeExclusives',
  accommodation: 'accommodation',
};

export const SMALL_GEO_TYPES = new Set([
  'street_address',
  'route',
  'intersection',
  'premise',
  'subpremise',
  'postal_code',
  'plus_code',
  'airport',
  'point_of_interest',
  'park',
  'natural_feature',
  'neighborhood',
  'administrative_area_level_4',
  'administrative_area_level_5',
  'administrative_area_level_6',
  'administrative_area_level_7',
  'sublocality',
  'sublocality_level_1',
  'sublocality_level_2',
  'sublocality_level_3',
  'sublocality_level_4',
  'sublocality_level_5',
]);
export const PLACES_SEARCH_OPTIONS = {
  locationBias: {
    center: { lat: 53.48, lng: -2.24 }, // Manchester, UK
    radius: 100000 /* in metres */,
  },
};

export const PLACES_DEBOUNCE_MS = 300;

export const createDefaultSearchState = (overrides = {}) => ({
  anglers: 1,
  nonAnglers: 0,
  selectedSession: null,
  dateMethod: 'Exact Dates',
  selectedMonths: [],
  bookingDates: [],
  bookingTypes: {
    specificSwims: false,
    watercraftTickets: false,
    lakeExclusives: false,
    accommodation: false,
  },
  selectedLocation: null,
  trips_abroad: false,
  ...overrides,
});
